import React, { useEffect, useState } from 'react';
import { AppShell, Box, Burger, Group, Image } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import Sidebar from '../components/shell/Sidebar.jsx';

const DriveOffShellLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpened, { toggle: toggleMobile, close: closeMobile }] = useDisclosure(false);
  const isMobile = useMediaQuery('(max-width: 48em)');
  const [, setProModeUnlocked] = useState(() => localStorage.getItem('proModeUnlocked') === 'true');

  useEffect(() => {
    if (!isMobile) {
      closeMobile();
    }
  }, [isMobile, closeMobile]);

  return (
    <>
      <AppShell
        header={{ height: 56, collapsed: !isMobile }}
        navbar={{
          width: { base: 280, sm: sidebarCollapsed ? 76 : 260 },
          breakpoint: 'sm',
          collapsed: { mobile: !mobileOpened },
        }}
        padding={0}
        styles={{
          header: {
            backgroundColor: '#0B0F14',
            borderBottom: '1px solid rgba(148, 163, 184, 0.14)',
          },
          navbar: {
            backgroundColor: '#0B0F14',
            borderRight: '1px solid rgba(148, 163, 184, 0.14)',
          },
          main: {
            backgroundColor: '#05070D',
          },
        }}
      >
        <AppShell.Header>
          <Group h="100%" px="sm" justify="space-between" wrap="nowrap">
            <Group gap="sm" wrap="nowrap">
              <Burger
                opened={mobileOpened}
                onClick={toggleMobile}
                size="sm"
                color="#E5E7EB"
                aria-label="Toggle navigation"
              />
              <Image src="/images/logo-white.svg" alt="DriveOffShield" w={130} fit="contain" />
            </Group>
          </Group>
        </AppShell.Header>
        <AppShell.Navbar>
          <Sidebar
            onProModeChange={setProModeUnlocked}
            collapsed={sidebarCollapsed}
            onToggleCollapsed={() => setSidebarCollapsed((prev) => !prev)}
            isMobile={isMobile}
            onNavigate={closeMobile}
          />
        </AppShell.Navbar>
        <AppShell.Main>
          <Box
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: isMobile ? 0 : '18px 18px 0 0',
              minHeight: '100vh',
              overflow: 'hidden',
            }}
          >
            <Outlet />
          </Box>
        </AppShell.Main>
      </AppShell>
    </>
  );
};

export default DriveOffShellLayout;
